<script setup lang="ts">
import { stringIsNotNullOrWhitespace } from '@/helpers/stringHelpers';
import { ref } from 'vue';
import SearchIcon from './svg/Search.vue';
import Close from './svg/Close.vue';
import { watch } from 'vue';

const props = defineProps<{
  modelValue?: string,
  isReadonly?: boolean
}>();

const emit = defineEmits<{
  (event: 'submit:searchTerm', value: string|undefined): void
  (event: 'reset:searchTerm'): void
}>();

const searchTerm = ref<string>('');

function handleEnterKey(event: Event) {
  event.preventDefault();
  handleSubmitSearchTerm();
}

// function handleResetSearchTerm() {
//   emit('reset:searchTerm');
//   searchTerm.value = undefined;
// }

function handleSubmitSearchTerm() {
  if (stringIsNotNullOrWhitespace(searchTerm.value)) {
    emit('submit:searchTerm', searchTerm.value);
  }
}

watch(searchTerm, (newValue) => {
  if (!stringIsNotNullOrWhitespace(newValue)) {
    emit('submit:searchTerm', undefined);
  }
});
</script>

<template>
  <div class="searchBox searchBox_productList">
    <input id="searchTermInput"
           v-model="searchTerm"
           type="search"
           name="searchTerm"
           class="searchBox-input"
           :aria-label="$t('search')"
           :placeholder="$t('search')"
           @keydown.enter="handleEnterKey"
           autocomplete="off" />
    <button type="button"
            class="searchBox-btn"
            @click="handleSubmitSearchTerm"
            :name="$t('search')">
      <SearchIcon></SearchIcon>
    </button>
  </div>
</template>

<style lang="scss">

</style>